import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { useMediaQuery } from "@mui/material";

function SearchBar({ setFilterData, searchData, description, setSearchData }) {
  const isSmallScreen = useMediaQuery("(max-width: 625px)");
  const handleSearch = (e) => {
    e.preventDefault();
    if (searchData?.description === "" && searchData?.location === "") {
      return;
    }
    setFilterData((prev) => ({
      ...prev,
      description: searchData?.description || description,
      location: searchData?.location,
    }));
  };

  return (
    <div className="searchBarMain">
      <form>
        <div
          className="border border-2 rounded-pill"
          style={{ padding: "6px 6px 6px 12px", backgroundColor: "#F3F8FB" }}
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <div
              className="d-flex align-items-center"
              style={{
                gap: "8px",
              }}
            >
              <SearchIcon fontSize="small" />
              <input
                type="text"
                className="border-0 bg-transparent"
                placeholder="Job Title"
                style={{ width: isSmallScreen ? "95px" : "195px" }}
                onChange={(e) => {
                  setSearchData((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }));
                }}
                value={searchData.description}
              />
            </div>
            <div
              className="border-2 border-end"
              style={{ borderColor: "gray", height: "3ch" }}
            ></div>
            <div className="d-flex align-items-center">
              <LocationOnOutlinedIcon fontSize="small" />
              <input
                type="text"
                className="border-0 bg-transparent px-2"
                placeholder="Location"
                style={{ width: isSmallScreen ? "100px" : "195px" }}
                onChange={(e) => {
                  setSearchData((prev) => ({
                    ...prev,
                    location: e.target.value,
                  }));
                }}
              />
              <button
                className="rounded-circle border-0"
                style={{
                  backgroundColor: "#165DFF",
                  width: "32px",
                  height: "32px",
                  display: "grid",
                  placeItems: "center",
                }}
                onClick={handleSearch}
              >
                <SearchIcon sx={{ color: "#FFFFFF", fontSize: "22px" }} />
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default SearchBar;
